
import './index.css'


interface ActionButtonProps {
  text: string,
  type: 'confirm' | 'cancel' | 'apply' | 'reset',
  disabled?: boolean,
  onClick: () => void
}

export default function ActionButton({ text, type, disabled, onClick }: ActionButtonProps) {
  return (
    <div className="action-button">
      <button
        type="submit"
        className={`action-button-btn action-button-btn__${type}`}
        onClick={onClick}
        disabled={disabled}
      >
        {text}
      </button>
    </div>
  )
}